import { SvgIcon, type SvgIconProps } from "@mui/material";
import React from "react";

export const ExcelIcon = (props: SvgIconProps) => {
	return (
		<SvgIcon {...props} viewBox="0 0 24 24">
			{/* Document background */}
			<path
				d="M14 2H6C4.9 2 4 2.9 4 4v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6z"
				fill="#217346"
			/>
			{/* Folded corner */}
			<path d="M14 2v6h6l-6-6z" fill="#185C37" />
			{/* Grid lines - horizontal */}
			<path d="M7 11h10v1H7zM7 14h10v1H7zM7 17h10v1H7z" fill="#fff" />
			{/* Grid lines - vertical */}
			<path d="M10 10h1v9h-1zM14 10h1v9h-1z" fill="#fff" />
		</SvgIcon>
	);
};
